import { useEffect, useState } from "react";
import { Form } from "@rjsf/mui";
import validator from "@rjsf/validator-ajv6";
import { useParams } from "react-router-dom";
import { Grid, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLazyGetShowWidgetsQuery } from "../../redux/slices/widgetsApi";
import WidgetPreview from "./WidgetPreview";
import { setPreviewMode } from "../../redux/slices/widgetsSlice";
import IconButton from "@mui/material/IconButton";
import { widgetShowCleanUp } from "../../redux/slices/widgetsSlice";
import { setUpdating } from "../../redux/slices/widgetsSlice";
import GroupsSelector from "../statistics/GroupsSelector";
import { setMessage } from "../../redux/slices/snackbarSlice";
import { useUpdateWidgetMutation } from "../../redux/slices/widgetsApi";
import { useLazyGetStatisticsQuery } from "../../redux/slices/statisticApi";
import WidgetsAutocomplete from "./WidgetsAutocomplete";
import CustomSnackbar from "../../utils/Snackbars";
import { useCreateWidgetMutation } from "../../redux/slices/widgetsApi";
import { Box } from "@material-ui/core";
import { getWidget } from "@rjsf/utils";
const ObjectFieldTemplate = (props) => {
  return (
    <Grid container alignItems="center" rowSpacing={3} spacing={2}>
      {props.properties.map((element, i) => {
        if (i == 6) {
          return (
            <Grid key={element.id} alignItems="center" item xs={12}>
              {element.content}
            </Grid>
          );
        }
        return (
          <Grid key={element.id} alignItems="center" item xs={6}>
            {element.content}
          </Grid>
        );
      })}
    </Grid>
  );
};
const tagsEnum = [
  { label: "network", value: "network" },
  { label: "device", value: "device" },
  { label: "group and district", value: "group_and_district" },
];
const typeEnum = [
  { label: "single value", value: "single_value" },
  { label: "pie chart", value: "pie_chart" },
  { label: "line chart", value: "line_chart" },
];
const WidgetShow = () => {
  const dispatch = useDispatch();
  const widget = useSelector((state) => state?.widgetsSlice?.widgetShow);
  const loading = useSelector((state) => state?.loadingSlice?.loading);
  const [widgetType, setWidgetType] = useState(null);
  const [widgetStatistic, setWidgetStatistic] = useState(null);
  const { t } = useTranslation();
  const [updateWidget, { isSuccess: updateSuccess }] =
    useUpdateWidgetMutation();
  const { id } = useParams();
  const [rate, setRate] = useState(null);

  const [getShowWidget] = useLazyGetShowWidgetsQuery();
  const statistics = useSelector((state) => state?.statisticsSlice?.statistics);

  const statisticsEnum = statistics.map((item) => ({
    label: item?.name,
    value: item?.id,
  }));

  /*   const rate = +widget?.attributes?.refresh_rate / 1000; */
  useEffect(() => {
    setRate(widget?.attributes?.refresh_rate / 1000);
    console.log("pisos", typeof widget?.attributes?.refresh_rate);
    console.log("pisos1", typeof rate);
  }, [widget, rate]);
  const [getStatistics] = useLazyGetStatisticsQuery();
  const [formData, setFormData] = useState({});
  useEffect(() => {
    dispatch(setUpdating(true));
    dispatch(setPreviewMode(true));
    getStatistics();
    return () => {
      dispatch(setUpdating(false));
      dispatch(setPreviewMode(false));
    };
  }, []);
  useEffect(() => {
    getShowWidget(id);
  }, [id]);

  useEffect(() => {
    if (updateSuccess) {
      debugger;
      dispatch(setMessage(t("update_success")));
    }
  }, [updateSuccess]);
  const onSubmitClick = (val) => {
    const attributes = {
      ...val,
      refresh_rate: val.refresh_rate * 1000,
      tags: [val.tags],
    };
    console.log(attributes);
    updateWidget({ attributes: attributes, id: widget?.attributes?.id });
  };
  useEffect(() => {
    setWidgetType(widget?.attributes?.type);
    setWidgetStatistic(widget?.attributes?.statistic_id);
  }, [widget?.attributes?.type, widget?.attributes?.statistic_id]);

  const statisticId = widget?.attributes?.statistic_id;

  const schema = widgetType !== null &&
    widgetStatistic !== null && {
      title: "New statistic",
      type: "object",
      properties: {
        name: {
          id: 0,
          type: "string",
          title: t("name"),
          default: widget?.attributes?.name,
        },

        refresh_rate: {
          id: 2,
          type: "number",
          title: t("refresh_rate"),
          default: rate,
        },
        type: {
          id: 3,
          type: "string",
          title: t("type"),
          data: [...typeEnum],
          default: widgetType,
        },
        tags: {
          id: 4,
          type: "string",
          title: t("tags"),
          data: [...tagsEnum],
          default: widget?.attributes?.tags[0],
        },
        statistic_id: {
          id: 5,
          type: "number",
          title: t("statistic"),
          data: [...statisticsEnum],
          default: widgetStatistic,
        },
        groups: {
          id: 6,
          type: "string",
          title: t("groups"),
        },
        description: {
          id: 1,
          type: "string",
          title: t("description"),
          default: widget?.attributes?.description,
        },
      },
    };
  const uiSchema = {
    "ui:ObjectFieldTemplate": ObjectFieldTemplate,

    description: {
      "ui:options": {
        widget: "textarea",
        minRows: 15,
      },
    },
    type: {
      "ui:field": "autocomplete",
    },
    tags: {
      "ui:field": "autocomplete",
    },
    statistic_id: {
      "ui:field": "autocomplete",
    },
    groups: {
      "ui:field": "gropus",
    },
    "ui:submitButtonOptions": {
      submitText: t("update"),
    },
    /*     "ui:order": [
      "name",
      "type",
      "groups",
      "connection_type",
      "description",
      "sql",
      "connection_parameters",
    ], */
  };
  const fields = {
    autocomplete: WidgetsAutocomplete,
    gropus: GroupsSelector,
  };
  const widgetPreview = {
    ...widget?.attributes,
    name: formData.name,
    description: formData.description,
    tags: [formData.tags],
    type: formData.type,
  };
  const customValidate = (formData, errors) => {
    if (!formData?.name) {
      errors?.name?.addError("is a required property");
    }
    if (!formData?.description) {
      errors?.description?.addError("is a required property");
    }
    if (!formData?.type) {
      errors?.type?.addError("is a required property");
    }
    if (!formData?.refresh_rate) {
      errors?.refresh_rate?.addError("is a required property");
    }
    if (!formData?.statistic_id) {
      errors?.statistic_id?.addError("is a required property");
    }
    if (formData?.groups.length < 1) {
      errors?.groups?.addError("is a required property");
    }
    if (!formData?.tags) {
      errors?.tags?.addError("is a required property");
    }
    return errors;
  };
  useEffect(() => {
    //clean up func
    return () => {
      dispatch(widgetShowCleanUp());
    };
  }, []);
  useEffect(() => {
    console.log("stxenum", statisticsEnum);
  }, [statisticsEnum]);
  return (
    <>
      {widget &&
      rate &&
      typeof rate !== "object" &&
      widgetType &&
      widgetStatistic &&
      statisticsEnum.length > 0 ? (
        <>
          <CustomSnackbar />
          <Grid container>
            <Grid item xs={8}>
              <Form
                schema={schema}
                fields={fields}
                formData={formData}
                customValidate={customValidate}
                showErrorList={false}
                onChange={(changeEvent) => setFormData(changeEvent.formData)}
                onSubmit={(values) => {
                  onSubmitClick(values.formData);
                }}
                validator={validator}
                uiSchema={uiSchema}
              />
            </Grid>
            <Grid item xs={3}>
              <WidgetPreview widget={widgetPreview} />
            </Grid>
          </Grid>
        </>
      ) : (
        <></>
      )}
    </>
  );
};

export default WidgetShow;
